import { Body, Card, CenteredBox, Expertise } from '../widgets'
import { indexFromValue, practices, valueColors, valueTextColors } from '../../lookups'
import { useEffect, useState } from 'react'

export const PracticeComparisonCard = ({ practice, yours, yourChange, comparison, comparisonChange, onClose, displayMode }) => {
  const { name } = practices[practice] || {}
  const [angle, setAngle] = useState(Math.random() * 16 - 8)

  useEffect(() => {
    if(typeof practice === 'number') {
      setAngle(Math.random() * 16 - 8)
    }
  }, [practice])

  return (
    <Card
      column
      width={335}
      rotate={angle}
      background={valueColors[indexFromValue(yours)]}
      textColor={valueTextColors[indexFromValue(yours)]}
      p={24}
      gap={16}
      onClose={!displayMode && onClose}
    >
      <Body alt bold>
        {name}
      </Body>

      <CenteredBox fullWidth>
        <CenteredBox column width="50%" gap={12}>
          <Body alt bold align="center" lineHeight={1.2}>
            Your<br/>result
          </Body>
          <Expertise
            value={yours}
            change={yourChange}
            valueSize={32}
            expertiseSize={16}
            color={valueTextColors[indexFromValue(yours)]}
          />
        </CenteredBox>
        <CenteredBox column width="50%" gap={16}>
          <Body alt bold align="center" lineHeight={1.2}>
            Comparison result
          </Body>
          <Expertise
            value={comparison}
            change={comparisonChange}
            valueSize={32}
            expertiseSize={16}
            color={valueTextColors[indexFromValue(yours)]}
          />
        </CenteredBox>
      </CenteredBox>
    </Card>

  )
}